__webpack_require__.p = "/Text-Analyzer/";